import React from 'react';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Spacing from '@marvelapp/marvel-ui/spacing';
import Heading from '@marvelapp/marvel-ui/heading';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Align from '@marvelapp/marvel-ui/align';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';

const questions = [
  {
    id: 1,
    name: '​Do the apps work offline?',
    answer:
      "​Yes! We package up your prototype as an app (.apk) so once ​it's installed it'll run without an internet connection.",
  },
  {
    id: 2,
    name: '​Can I put the app in the Play Store?',
    answer:
      'Yes! You can turn a bunch of sketches or designs into something you can validate and test for real.',
  },
  {
    id: 3,
    name: '​Does Marvel export reusable code?',
    answer:
      "​The app we generate still contains your designs as images, it's not something you would give to a developer.",
  },
  {
    id: 4,
    name: '​How much does it cost?',
    answer: '​Marvel Pro starts at $12 per month, per person.',
  },
];

const items = questions.map(question => (
  <GridItem columnSpan={2} columnSpanM={1} key={question.id}>
    <Align type="center" typeM="left">
      <Spacing size="s" type="padding" position="topBottom">
        <Heading tag="h3" weight="semibold" size="l">
          {question.name}
        </Heading>
      </Spacing>
      <Paragraph size="m" color="slate">
        {question.answer}
      </Paragraph>
    </Align>
  </GridItem>
));

export default function Questions() {
  return (
    <Spacing size="xl" type="padding" position="topBottom">
      <MaxWidth value={720}>
        <Spacing size="xl" type="padding" position="bottom">
          <Heading tag="h2" weight="semibold" size="xl">
            Common questions
          </Heading>
        </Spacing>
        <Grid columns={2} size="l">
          {items}
        </Grid>
      </MaxWidth>
    </Spacing>
  );
}



// WEBPACK FOOTER //
// ./src/pages/android-app-builder/questions.js